// extracted by mini-css-extract-plugin
export default {"root":"PlasmicBankTransferButton_root__1Sr2V","text":"PlasmicBankTransferButton_text__qo0qN"};